/**
 * Get pixels from hub
 * @param {{ affId: string, sub1: string }} params
 * @returns {Promise<GetPixelResponse>}
 */

export const getPixels = async ({ affId, sub1 }) => {
  const response = await fetch(
    'https://www.turbodebt.com/api/get-pixels-static',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ affId, sub1 }),
    },
  )

  const data = await response.json()
  return data.data
}
